export default __webpack_public_path__ + "static/media/gov_ro_mobile.31b80fef.svg";